import { render, staticRenderFns } from "./AdditionalFieldsTextArea.vue?vue&type=template&id=517e598e&scoped=true&lang=pug&"
import script from "./AdditionalFieldsTextArea.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFieldsTextArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517e598e",
  null
  
)

export default component.exports